import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "/api/",
});

/**
 * Request interceptor — automatically attaches:
 *  - Authorization: Bearer <token>  (if saved in localStorage)
 *  - X-Employee-Id: <id>            (active employee for backend permission checks)
 */
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("access_token");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }

    const employeeId = localStorage.getItem("active_employee_id");
    if (employeeId) {
      config.headers["X-Employee-Id"] = employeeId;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

/**
 * Response interceptor — handle 403 Forbidden from backend permission checks
 * gracefully so the user sees a consistent message.
 */
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 403) {
      const detail = error.response?.data?.detail || "Access Denied";
      console.warn("[Permission Denied]", detail);
      // Optionally dispatch a global event to show a toast in the UI
      window.dispatchEvent(
        new CustomEvent("permission-denied", { detail })
      );
    }
    return Promise.reject(error);
  }
);

export default api;
